<template>

    <div class="container-horizontal help-bar" v-bind:class="{'container-horizontal_flex-end': !back}">
        <span v-bind:class="{white: isWhite}" @click="goBack " v-if="back"><　<ruby>戻<rt>もど</rt></ruby>る　</span>
        <span class="help" v-bind:class="{ backgroudWhite: isWhite}" @click="helpClick" v-if="isHelp"> ? </span>
    </div>
</template>

<script>
    export default {
        name: "MenuOption",
        props: ['backRoute', "isWhite" , "back", "isHelp"],
        methods: {
            goBack() {
                if (this.backRoute) {
                    this.$router.push(this.backRoute);
                } else {
                    this.$emit('backIsClick')
                }
            },

            helpClick() {
                this.$emit('help')
            }
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>
    span {
        font-size: 1em;
        font-weight: bold;
        cursor: pointer;
    }

    span:hover {
        color: #dad32b;
    }

    .help {
        background-color: black;
        color: white;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
    }

    .white {
        color: white !important;
        z-index: 3;
        padding: 0 0 0 20px;

    }

    .backgroudWhite {
        background-color: white !important;
        color: #2b86d9 !important;
        z-index: 3;
    }

</style>
